import { motion } from "framer-motion"
import MaterialsQuotationWelcomeBlock from "../MaterialsQuotationWelcomeBlock.tsx"
import styles from "../MaterialsQuotationWelcome.module.scss"
import calcStyles from "../CalculadoraDeMateriales.module.scss"

type CalculadoraIntegratedWelcomeProps = {
  showIntegratedEstimationWelcome: boolean
  totalCatalogMaterialsLabel: string
  onNavigateToCostEstimation: () => void
  onBeginManual: () => void
  onFileChosen: (file: File) => void
}

const CalculadoraIntegratedWelcome = ({
  showIntegratedEstimationWelcome,
  totalCatalogMaterialsLabel,
  onNavigateToCostEstimation,
  onBeginManual,
  onFileChosen,
}: CalculadoraIntegratedWelcomeProps) => {
  return (
    <div className={calcStyles.container_welcomeFull}>
      <div className={calcStyles.container_welcomeFormSlot}>
        <div className={styles.formContainer}>
          <motion.div
            className={styles.form}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <MaterialsQuotationWelcomeBlock
              isLoading={false}
              onBeginManual={onBeginManual}
              onFileChosen={onFileChosen}
              onGoToCostEstimation={showIntegratedEstimationWelcome ? undefined : onNavigateToCostEstimation}
              title={
                showIntegratedEstimationWelcome
                  ? "Calculá una estimación de costos de materiales"
                  : "Armá tu listado de materiales"
              }
              description={
                showIntegratedEstimationWelcome
                  ? `Elegí cómo empezar para armar tu lista y obtener una referencia estimada de costos con más de ${totalCatalogMaterialsLabel} materiales disponibles en el catálogo.`
                  : `Elegí cómo arrancar: manual o asistido con IA. Después publicamos tu lista para recibir presupuestos en Edify y notificamos a proveedores relevantes según la zona indicada, con más de ${totalCatalogMaterialsLabel} materiales disponibles en el catálogo.`
              }
              manualTitle={showIntegratedEstimationWelcome ? "Carga manual" : "Paso a paso"}
              manualBullets={
                showIntegratedEstimationWelcome
                  ? [
                      "Buscá por nombre o elegí una categoría para empezar.",
                      "Agregá materiales del catálogo o creá materiales personalizados.",
                      "Ajustá cantidades para obtener una estimación orientativa.",
                    ]
                  : [
                      "Buscá por nombre o elegí una categoría para empezar rápido.",
                      "Agregá materiales del catálogo o creá materiales personalizados.",
                      "Ajustá cantidades y revisá todo antes de publicar.",
                    ]
              }
              manualCta={showIntegratedEstimationWelcome ? "Cargar manualmente" : "Cargar manualmente"}
              assistedTitle="Desde un archivo"
              assistedBadge="IA"
              assistedBullets={
                showIntegratedEstimationWelcome
                  ? [
                      "Detectamos materiales y cantidades del archivo para ayudarte a arrancar más rápido.",
                      "Te mostramos una primera base de lista para revisar antes de estimar.",
                      "Después podés ajustar la lista: agregar, quitar o cambiar cantidades.",
                    ]
                  : [
                      "Detectamos materiales y cantidades del archivo cuando el contenido lo permite.",
                      "Te mostramos una primera lista para que arranques más rápido.",
                      "Antes de publicar, podés ajustar la lista: agregar, quitar o cambiar cantidades.",
                    ]
              }
              assistedCta="Elegir archivo"
              assistedHint={showIntegratedEstimationWelcome ? "O soltá el archivo en esta zona" : "O soltá el archivo en esta zona"}
              assistedDisabled={false}
            />
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default CalculadoraIntegratedWelcome
